export default "__VITE_ASSET__B2DqWwYf__"